export const PROSE_READER_NAMESPACE = `@prose-reader/core`
export const VIEWPORT_ADJUSTMENT_THROTTLE = 0
export const PAGINATION_UPDATE_AFTER_VIEWPORT_ADJUSTMENT_DEBOUNCE = 200
/**
 * @important These prefixes needs to be available and in sync with the constants.scss file
 */
export const HTML_PREFIX = `prose-reader`
export const HTML_STYLE_PREFIX = `${HTML_PREFIX}-style`
export const HTML_ATTRIBUTE_DATA_READER_ID = `data-${HTML_PREFIX}-id`
export const HTML_PREFIX_VIEWPORT = `${HTML_PREFIX}-viewport`
export const HTML_PREFIX_SCROLL_NAVIGATOR = `${HTML_PREFIX}-scroll-navigator`
export const HTML_PREFIX_SPINE_ITEM = `${HTML_PREFIX}-spine-item`
export const CSS_VAR_ABSOLUTE_VIEWPORT_WIDTH = `--${HTML_PREFIX}-absolute-viewport-width`
export const CSS_VAR_ABSOLUTE_VIEWPORT_HEIGHT = `--${HTML_PREFIX}-absolute-viewport-height`
